import { formatDate } from "../../../../utils/DateFormat";

export const ASSET_PLACEHOLDER_IMAGE = "/images/default-profile.png";

export const getAssetImage = (asset) => {
  const logo = Array.isArray(asset?.logo)
    ? asset.logo.find((item) => item?.isImage && item?.value)
    : null;

  if (logo?.value) return logo.value;
  if (asset?.image?.url) return asset.image.url;
  if (typeof asset?.image === "string") return asset.image;

  return ASSET_PLACEHOLDER_IMAGE;
};

export const getAssetOwners = (asset) => {
  if (Array.isArray(asset?.owner) && asset.owner.length > 0) {
    return asset.owner.filter(Boolean).join("; ");
  }

  if (typeof asset?.owner === "string" && asset.owner.trim()) {
    return asset.owner;
  }

  return asset?.createdBy?.fullName || "--";
};

export const getAssetCategory = (asset) =>
  asset?.serviceId?.category?.categoryName ||
  (Array.isArray(asset?.groupNames) && asset.groupNames.length > 0
    ? asset.groupNames.filter(Boolean).join("; ")
    : "--");

export const getAssetType = (asset) => {
  if (Array.isArray(asset?.groupNames) && asset.groupNames.length > 0) {
    const groups = asset.groupNames.filter(Boolean);
    return groups.length ? groups.join("; ") : "--";
  }

  return "--";
};

export const getAssetClassification = getAssetType;

export const mapOriginalProfileToAssetRow = (asset, index, page, limit) => {
  const name = asset?.brand || "--";
  const type = getAssetType(asset);
  const applicationDate = formatDate(asset?.createdDate || asset?.createdAt);

  return {
    id: limit * (page - 1) + index + 1,
    _id: asset?._id,
    nav_id: asset?._id,
    image: getAssetImage(asset),
    name,
    brand: name,
    type,
    classification: type,
    profileCode: asset?.profileCode || "--",
    applicationDate,
    submittedDate: applicationDate,
    certificateNumber: asset?.numberOfCertificates || "--",
    owner: getAssetOwners(asset),
    issueDate: formatDate(asset?.issueDate),
    expiryDate: formatDate(asset?.expiryDate),
    status: asset?.status || "--",
  };
};

export const mapOriginalProfilesToAssetRows = (assets, page, limit) =>
  (assets || []).map((asset, index) =>
    mapOriginalProfileToAssetRow(asset, index, page, limit),
  );
